import { Button } from "antd";
import CheckmarkIcon from "../../../assets/icons/CheckmarkIcon";
import { ModalComponentProps } from "../../../types";
import CustomModal from "../../ui/CustomModal";

interface TSuccessModal extends ModalComponentProps {
  heading?: string;
  subHeading?: string;
}

export default function SuccessModal({
  handleClose,
  heading,
  subHeading,
  ...rest
}: TSuccessModal) {
  return (
    <CustomModal
      title=""
      {...rest}
      handleClose={handleClose}
      width={400}
      footer={null}
    >
      <div className="flex justify-center my-4">
        <div className="text-[#11A75C] bg-[#D7FFEB] p-4 rounded-full">
          <CheckmarkIcon />
        </div>
      </div>
      <div className="font-semibold text-[#2D3643] text-center my-3">
        {heading}
      </div>
      <div className="text-[#455468] text-center">{subHeading}</div>

      <Button
        className="flex items-center gap-2 border-[#FFD3C0] bg-[#FFF1EB] text-primary my-4 mx-auto"
        onClick={() => {
          handleClose();
        }}
      >
        Okay
      </Button>
    </CustomModal>
  );
}
